"use client";

import { getS3ImageUrl } from "@/utils/routes";
import Image from "next/image";
import Link from "next/link";
import classes from "./ShowBannersSection.module.css";

import { getSectionStyle } from "@/utils";
import "swiper/css";
import "swiper/css/navigation";
import { Autoplay, Navigation } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";

interface Props extends WidgetSectionProps {
	section?: boolean;
}

const ShowBannersSlider = ({ section = true, widget }: Props) => {
	const settings = widget?.data?.settings || {};
	const col = settings?.col || 3;
	const width = settings?.width || 1280;

	const classNames = [classes.ShowBannersSection, classes["col" + col]];
	if (section) classNames.push(classes.section);

	const banners = widget?.data?.images || [];

	if (banners.length === 0) return null;

	return (
		<div className={classNames.join(" ")} style={getSectionStyle(settings)}>
			<div
				className={
					settings?.containerType === "full" ? "" : "container"
				}>
				<div className={classes.slider}>
					<Swiper
						spaceBetween={settings.gap ?? 8}
						slidesPerView={col}
						// navigation={true}
						freeMode={true}
						autoplay={
							settings?.autoplay
								? {
										delay: settings?.delay ?? 5000,
								  }
								: false
						}
						breakpoints={{
							640: {
								slidesPerView: Math.min(col, 2.5),
							},
							768: {
								slidesPerView: Math.min(col, 3.5),
							},
							1024: {
								slidesPerView:
									col <= 4 ? col : Math.max(col, 4.5),
							},
						}}
						className={classes.swiper}
						modules={[Navigation, Autoplay]}>
						{banners.map((banner, index) => {
							let classNames = `${classes.banner}`;

							let height = settings?.height || 800;

							return (
								<SwiperSlide key={banner.image || banner.link?.url || `show-banner-${index}`}>
									<div
										className={classNames}
										title={banner.link?.hyperLinkText}>
										<Link
											href={banner.link?.url || "#"}
											className={
												!banner.link ? "no-link" : ""
											}>
											<Image
												src={getS3ImageUrl(
													banner.image
												)}
												alt={
													banner.link
														?.hyperLinkText ||
													"Banner"
												}
												blurDataURL={
													"https://www.unfe.org/wp-content/uploads/2019/04/SM-placeholder.png"
												}
												placeholder="blur"
												layout="responsive"
												width={width}
												height={height}
												unoptimized={true}
												style={{
													aspectRatio: width / height,
													objectFit:
														(settings?.objectFit ||
															"contain") as any,
												}}
											/>
										</Link>
									</div>
								</SwiperSlide>
							);
						})}
					</Swiper>
				</div>
			</div>
		</div>
	);
};

export default ShowBannersSlider;
